import React, { useCallback, useEffect, useState } from "react";
import PageContainer from "../components/PageContainer";
import { infographics_mockup } from "./Infographics";
import { useNavigate, useParams } from "react-router-dom";
import { FaDownload } from "react-icons/fa";
import { getDocsInfo } from "../api/document";
import { toImagePath } from "../utils/globalFunctions";
import MainCard from "../components/MainCard";
import Container from "../components/Container";

const InfographicsDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  // const [pageData, setPageData] = useState([]);

  const [infographicDetail, setInfographicDetail] = useState(null);
  const [otherInfographics, setOtherInfographics] = useState([]);

  const getData = useCallback(
    () =>
      getDocsInfo()
        .then((res) => {
          const infographics = res.docsset.find(
            (item) => item.pdflink._id === id
          );
          const otherInfo = res.docsset
            .filter((item) => item.pdflink._id !== id)
            .slice(0, 3);

          setInfographicDetail(infographics);
          setOtherInfographics(otherInfo);
        })
        .catch((err) => console.log(err)),
    [setInfographicDetail, setOtherInfographics, id]
  );

  useEffect(() => {
    getData();
  }, [getData]);

  const displayOther = (
    <div>
      <h4 className="text-xl font-bold text-black mb-4">
        เอกสาร Infographic อื่นๆ
      </h4>
      <div className="mx-auto max-w-[600px]">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {otherInfographics.slice(0, 3)?.map((img) => (
            <div
              key={img.pdflink._id}
              className="w-[150px] h-[180px] rounded-lg overflow-hidden shadow-lg cursor-pointer"
              onClick={() => navigate(`/infographics/${img.pdflink._id}`)}
            >
              <img
                src={toImagePath(img.cover.path)}
                alt={img.title}
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  return (
    <PageContainer
      title="Infographic"
      bgImg="/images/docs/infographic-banner.png"
    >
      <Container isAlignTop>
        <MainCard>
          {infographicDetail ? (
            <div>
              <div className="card-title bg-[#E9EAF8] justify-center p-2 text-black">
                {infographicDetail?.title}
              </div>
              <div className="flex flex-col gap-10">
                <p className="px-9 text-black">
                  {infographicDetail?.bookdetail}
                </p>
                <iframe
                  src={toImagePath(infographicDetail?.pdflink?.path)}
                  width="100%"
                  height="600px"
                />

                <div className="flex items-center gap-6">
                  <h6>{infographicDetail?.title}</h6>
                  <button
                    onClick={() =>
                      window.open(toImagePath(infographicDetail?.pdflink?.path))
                    }
                    className="btn btn-sm text-white btn-error rounded-badge font-light"
                  >
                    <FaDownload />
                    ดาวน์โหลด
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div className="min-h-[300px] flex items-center justify-center">
              <h4>ไม่พบข้อมูล ที่คุณต้องการ</h4>
            </div>
          )}

          <hr />
          <div className="mt-4">{displayOther}</div>
        </MainCard>
      </Container>
    </PageContainer>
  );
};

export default InfographicsDetail;
